// extracted by mini-css-extract-plugin
export default {"container":"Headers_container_Gedfr","content":"Headers_content_zDNSg","column":"Headers_column_MivQ0","edit":"Headers_edit_dw932"};